import * as React from 'react';

import { AboutRealtorDesktopContainer } from '../AboutRealtorContainer';
import { useSelector } from 'react-redux';
import { selectRealtorInfo } from '../../selectors/selectRealtorInfo';
import { selectCurrentRealtor } from '../../selectors/selectCurrentRealtor';

export function RealtorInfoDesktopContainer() {
  const realtorInfo = useSelector(selectRealtorInfo);
  const realtor = useSelector(selectCurrentRealtor);

  if (!realtorInfo?.data || !realtor) {
    return null;
  }

  return <AboutRealtorDesktopContainer realtorCardData={realtorInfo.data} realtor={realtor} />;
}
